/**
 * GraphQL returns at most 200 entries per request and errors at 201. The whole
 * published Inspiration library fits in one request, so it is fetched once and
 * filtered and sorted in memory.
 */
export const INSPIRATION_LIBRARY_LIMIT = 200;

export const inspirationLibraryQuery = `
  query InspirationLibrary($limit: Int!) {
    all_inspiration(limit: $limit) {
      total
      items {
        url
        title
        published_date
        seo {
          description
        }
        canonical_imageConnection {
          edges {
            node {
              url
            }
          }
        }
        department_referenceConnection {
          edges {
            node {
              ... on Department {
                url
              }
            }
          }
        }
        taxonomies {
          taxonomy_uid
          term_uid
        }
      }
    }
  }
`;
